import { useApi } from "../../../swr/useApi";
import { purchaseOrdersService } from "../../api_client";
import type { PurchaseOrderStatsDto } from "../../../api";

export function usePurchaseOrderStats() {
  return useApi<PurchaseOrderStatsDto>("purchase-order-stats", () =>
    purchaseOrdersService.getPurchaseOrderStats(),
  );
}
